import { render, staticRenderFns } from "./pos-incidents.vue?vue&type=template&id=81e2608a&scoped=true&"
import script from "./pos-incidents.ts?vue&type=script&lang=ts&"
export * from "./pos-incidents.ts?vue&type=script&lang=ts&"
import style0 from "./pos-incidents.scss?vue&type=style&index=0&id=81e2608a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e2608a",
  null
  
)

export default component.exports